import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

export const TalkingPointsNote = () => {
  return <Translation htmlAvailable text={getFormedEltTranslation('talking-point-note')} />
}
